import {
  Alert,
  Box,
  Button,
  Container,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  VStack,
  chakra,
} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { useState } from "react";
import { useAPI } from "@/contexts/APIContext";
import PageInfo from "@/components/PageInfo";
import { Controller, useForm } from "react-hook-form";
import { EmailIcon } from "@chakra-ui/icons";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const reasonOptions = [
  {
    value: "Difficulty accessing or viewing profiles, technical errors.",
    label: "Difficulty accessing or viewing profiles, technical errors.",
  },
  {
    value: "Irrelevant or incomplete information.",
    label: "Irrelevant or incomplete information.",
  },
  {
    value: "Discrepancies between advertised features and actual service.",
    label: "Discrepancies between advertised features and actual service.",
  },
  {
    value: "Dissatisfaction with the quality of feedback from the AI essay review tool.",
    label: "Dissatisfaction with the quality of feedback from the AI essay review tool.",
  },
  {
    value:
      "Encounter technical errors while interacting with both student profiles and the essay review tool",
    label:
      "Encounter technical errors while interacting with both student profiles and the essay review tool",
  },
  {
    value: "Incorrect order",
    label: "Incorrect order",
  },
  {
    value: "Other",
    label: "Other",
  },
];

const RefundForm = ({ onSubmitForm, loading }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  return (
    <Box mt={8}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <VStack>
          {/* NAME */}
          <FormControl isInvalid={!!errors.name}>
            <FormLabel fontWeight="bold">Cardholder Name</FormLabel>
            <Input
              type="text"
              placeholder="Ethan Zhang"
              {...register("name", { required: "Please enter your name." })}
            />
            {errors.name && <FormErrorMessage>{errors.name.message}</FormErrorMessage>}
          </FormControl>

          {/* EMAIL */}
          <FormControl isInvalid={!!errors.email}>
            <FormLabel fontWeight="bold">Email Used for Purchase</FormLabel>
            <Input
              type="email"
              placeholder="ethanzhang@gmail.com"
              {...register("email", {
                required: "Please enter an email address.",
              })}
            />
            {errors.email && <FormErrorMessage>{errors.email.message}</FormErrorMessage>}
          </FormControl>

          {/* SUBJECT */}
          <FormControl isInvalid={!!errors.subject}>
            <FormLabel fontWeight="bold">Which package did you purchase?</FormLabel>
            <Input
              type="text"
              placeholder="Name of package"
              {...register("subject", { required: "Please enter a subject." })}
            />
            {errors.subject && <FormErrorMessage>{errors.subject.message}</FormErrorMessage>}
          </FormControl>

          {/* BODY */}
          <FormControl isInvalid={!!errors.body}>
            <FormLabel fontWeight="bold">Reason for Refund</FormLabel>

            <Controller
              name="body"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  value={{ value: field.value, label: field.value }}
                  onChange={(e) => field.onChange(e.value)}
                  placeholder="Select reason for refund"
                  required
                  options={reasonOptions}
                />
              )}
            />

            {errors.body && <FormErrorMessage>{errors.body.message}</FormErrorMessage>}
          </FormControl>

          <Button colorScheme="green" type="submit" isLoading={loading} leftIcon={<EmailIcon />}>
            Submit
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

const SuccessAlert = () => (
  <Box bg="green.100" p={4} borderRadius="lg" mt={4} fontSize="lg">
    Great! We will send you an email.
  </Box>
);

const ErrorAlert = () => (
  <Alert status="error" borderRadius="lg" mt={4} fontSize="lg">
    Uh oh! There was an error sending this refund request. Shoot an email to contact@admityogi.com
    instead.
  </Alert>
);

export default function ContactUs() {
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const [loading, setLoading] = useState(false);

  const api = useAPI();
  const send = async (data) => {
    setSuccess(false);
    setFailure(false);
    try {
      setLoading(true);
      await api.postUnprotected("users/refund", undefined, data);
      setSuccess(true);
    } catch (e) {
      console.error(e);
      setFailure(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <PageInfo title="Request a Refund" themeColor="white" />
      <Box>
        <Navbar />
        <chakra.h1 my={10} textStyle="pageHeader" textAlign="center">
          Refund a Purchase
        </chakra.h1>
        <Container pb={10} maxW="container.sm">
          <Box layerStyle="md">
            <p>
              Accidentally made a purchase, or didn&apos;t get what you expected? We&apos;re sorry
              for this inconvenience! Don&apos;t worry, though - we&apos;re here to help. Please fill out the form below to request
              a refund.
            </p>
            <p>
              For additional assistance, feel free to reach us by email at{" "}
              <a href="mailto:contact@admityogi.com">contact@admityogi.com</a>.
            </p>
          </Box>
          {success && <SuccessAlert />}
          {failure && <ErrorAlert />}
          {!success && !failure && <RefundForm onSubmitForm={send} loading={loading} />}
        </Container>
      </Box>
      <Footer />
    </>
  );
}
